import { Alert, FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { useEffect, useState } from "react"


import { getItemsFromObjects, loadCourseCategories } from "../../../Component/DataLoader"
import { CourseLoader } from "../../fragement/CourseSelector"
import { apiResult, getUserSession } from "../../../Utils/Common"
import apis from "../../../api"


const MemberCourseSelect = (props) => {
    const {defaultValue,onChange,name,label,member_id} = props
    const [membercourses,setMemberCourses] = useState() 
    const [courses,setCourses] = useState() 
    const [categories,setCategories] = useState() 
    const [error,setError] = useState()
    getUserSession(apis)
    let loading = false
    useEffect(()=>{            
        MemberCourseLoader(member_id,apis,(data)=>setMemberCourses(data),setError)        
    },[member_id])
    useEffect(()=>{    
        if(loading)      return
        loading = true
        loadCourseCategories(apis,(data)=>setCategories(data),setError)      
        CourseLoader((data)=>setCourses(data),apis,false,setError)   
    },[])
    return <FormControl fullWidth sx={props.sx}>
        <InputLabel id="demo-simple-select-autowidth-label">{label ?label:"Select ordered course"}</InputLabel>
        <Select labelId="demo-simple-select-autowidth-label" disabled = {props.disabled}
            id="course_package"
            onChange={(e) => { 
                let id = e.target.value;
                let choose = false
                if(id>=0) {
                    for(let i=0;i<membercourses.length;i++) {
                        if(membercourses[i].id == id) {
                            onChange && onChange(name,membercourses[i])
                            choose = true
                            break
                        }
                    }
                }
                if(!choose) {
                    onChange && onChange(name,undefined)
                }
            }}
            defaultValue={defaultValue || -1}
            label={label ?label:"Select ordered course"}
        >
            <MenuItem value={-1}>Nothing</MenuItem>
            {membercourses && membercourses.map((item, idx) => {                
                let category = item.course_package?.category_id > 0 && getItemsFromObjects(categories,item.course_package.category_id)
                let course = item.course_package?.course_id > 0 && getItemsFromObjects(courses,item.course_package.course_id)
                let pp = category?.name + "/" + (course?course.name:"*") + " | " + (item.course_package?.billtype == 0?item.remained:(item.remained/60).toFixed(1)) + (item.course_package?.billtype == 1?" hours":" lessons")
                return <MenuItem key={idx} value={item.id}>{pp}</MenuItem>
            })}
        </Select>
        {error&&<Alert variant="error" onClose={()=>setError()}>{error}</Alert>}
    </FormControl>
}
const MemberCourseLoader = (member_id,apis,callback,errCallback) => {
    apis.membercourseGet(member_id,0).then(ret => {
        apiResult(ret, data => {                
            callback(data)
        },errCallback)
    })
}

export {MemberCourseLoader,MemberCourseSelect}